// Centralized configuration for LateralHiringReport
const lateralHiringReportConfig = {
  reportKey: "lateral_hiring_report_column_visibility",

  tableTemplate: [
    { field: "lateral_hiring_main_id",          headerName: "Lateral Hiring ID" },
    { field: "requisition_no",                  headerName: "Requisition No" },
    { field: "candidate_id",                    headerName: "Candidate ID" },
    { field: "candidate_full_name",             headerName: "Candidate Full Name" },
    { field: "application_current_csw_status",  headerName: "Application Status" },
    { field: "level",                           headerName: "Level" },
    { field: "level_group",                     headerName: "Level Group" },
    { field: "owning_department",               headerName: "Owning Department" },
    { field: "offer_location",                  headerName: "Offer Location" },
    { field: "acct_name",                       headerName: "Account Name" },
    { field: "primary_recruiter_name",          headerName: "Primary Recruiter" },
    { field: "so_marked_for_recruitment_date",  headerName: "SO Marked For Recruitment Date" },
    { field: "offer_release_date",              headerName: "Offer Release Date" },
    { field: "joining_date",                    headerName: "Joining Date" },
    { field: "joining_month",                   headerName: "Joining Month" },
    { field: "joining_year",                    headerName: "Joining Year" },
    { field: "primary_skills",                  headerName: "Primary Skills" },
    { field: "skill_group",                     headerName: "Skill Group" },
    { field: "niche_skill_name",                headerName: "Niche Skill Name" },
    { field: "niche_skill",                     headerName: "Niche Skill" },
    { field: "offer_release_year",              headerName: "Offer Release Year" },
    { field: "offer_week",                      headerName: "Offer Week" },
    { field: "offer_release_month",             headerName: "Offer Release Month" },
    { field: "original_offer_month",            headerName: "Original Offer Month" },
    { field: "last_updated_date",               headerName: "Last Updated Date" },
    { field: "report_extraction_date",          headerName: "Report Extraction Date" }
  ],

  filterTemplate: [
    { field: "skill_group",   headerName: "Skill Group" },
    { field: "level",         headerName: "Level" },
    { field: "offer_location", headerName: "Offer Location" },
    { field: "application_current_csw_status", headerName: "Application Status" },
    
    { field: "proposedbu",    headerName: "Proposed BU" },
    // { field: "location",      headerName: "Location" },
    { field: "city",          headerName: "City" },
    // { field: "region",        headerName: "Region" },
    { field: "original_offer_month",            headerName: "Original Offer Month" },
    { field: "joining_month",                   headerName: "Joining Month" },
  ]
};

export default lateralHiringReportConfig;
